import axios from 'axios'

export default {
    namespaced: true,
    state: {
        states: [],
    },
    getters: {
        states (state) {
            return state.states
        },
    },
    mutations: {
        SET_STATES(state, payload) {
            state.states = payload
        },
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.post('warranty/data')
            commit('SET_STATES', response.data.data.states)     
        },
        async submitClaim(_, data) {
            let response = await axios.post('warranty/save', data)
            return response.data
        },
    }
}